import { loadScript } from './loadScript.js'
import { getPlatform } from './getPlatform'

function askSubmitVerify(el = '#sc') {
  let smartCaptcha = window.smartCaptcha,
    NVC_Opt = window.NVC_Opt

  return new Promise(resolve => {
    if (window.NVC_Opt && smartCaptcha) {
      var ic = new smartCaptcha({
        renderTo: el,
        width: '100%',
        secvrf_layout: true,
        height: 42,
        default_txt: '点击按钮开始智能验证',
        success_txt: '验证成功',
        fail_txt: '验证失败，请在此点击按钮刷新',
        scaning_txt: '智能检测中',
        success: function(data) {
          console.log(NVC_Opt.token)
          console.log(data.sessionId)
          console.log(data.sig)
          resolve({
            token: NVC_Opt.token,
            sessionId: data.sessionId,
            sig: data.sig
          })
        }
      })
      ic.init()
    } else {
      resolve(null)
    }
  })
}

function consultAliVerify(config = {}) {
  return new Promise(resolve => {
    const platform = getPlatform()
    let today = new Date()
    const timeStamp = `${today.getFullYear()}${today.getMonth() +
      1}${today.getDay()}`
    const nc_appKey = 'FFFF000000000182B110'
    const nc_token = [nc_appKey, new Date().getTime(), Math.random()].join(':')

    const loadUrl = platform.isPc
      ? `//g.alicdn.com/sd/ncpc/nc.js`
      : `//g.alicdn.com/sd/nch5/index.js`
    let nc_sence = platform.isPc ? 'nc_register' : 'nc_message_h5'

    let slid_nc_opt = platform.isPc
      ? {
          renderTo: '#nc',
          appkey: nc_appKey,
          scene: nc_sence,
          token: nc_token,
          customWidth: '100%',
          trans: { key1: 'code0' },
          is_Opt: 0,
          language: 'cn',
          isEnabled: true,
          timeout: 3000,
          times: 5,
          apimap: {},
          callback: data => resolve({ ...data, nc_sence, nc_token, nc_appKey })
        }
      : {
          renderTo: '#nc',
          appkey: nc_appKey,
          scene: nc_sence,
          token: nc_token,
          trans: { key1: 'code0' },
          elementID: ['usernameID'],
          is_Opt: 0,
          language: 'cn',
          timeout: 10000,
          retryTimes: 5,
          errorTimes: 5,
          inline: false,
          apimap: {
            // 'analyze': '//a.com/nocaptcha/analyze.jsonp',
            // 'uab_Url': '//aeu.alicdn.com/js/uac/909.js',
          },
          bannerHidden: false,
          initHidden: false,
          callback: data => resolve({ ...data, nc_sence, nc_token, nc_appKey })
        }

    Object.assign(slid_nc_opt, config)

    loadScript(`${loadUrl}?t=${timeStamp}`).then(() => {
      const noCaptcha = window.noCaptcha
      if (platform.isPc) {
        let slid_nc = new noCaptcha(slid_nc_opt)
        slid_nc.upLang('cn', {
          _startTEXT: '请按住滑块，拖动到最右边',
          _yesTEXT: '验证通过',
          _error300:
            '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
          _errorNetwork:
            '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>'
        })
      } else {
        let nc = window.NoCaptcha.init(slid_nc_opt)
        window.NoCaptcha.setEnabled(true)
        nc.reset() //请务必确保这里调用一次reset()方法
        window.NoCaptcha.upLang('cn', {
          LOADING: '加载中...', //加载
          SLIDER_LABEL: '请向右滑动验证', //等待滑动
          CHECK_Y: '验证通过', //通过
          ERROR_TITLE: '非常抱歉，这出错了...', //拦截
          CHECK_N: '验证未通过', //准备唤醒二次验证
          OVERLAY_INFORM: '经检测你当前操作环境存在风险，请输入验证码', //二次验证
          TIPS_TITLE: '验证码错误，请重新输入' //验证码输错时的提示
        })
      }
    })
  })
}

export default {
  askSubmitVerify,
  consultAliVerify
}

export { askSubmitVerify, consultAliVerify }
